<template>
  <div class="d-flex align-center justify-center">This is under construction</div>
</template>

<script>
export default {};
</script>

<style></style>
